import React from "react";
import { Navigate } from "react-router-dom";
import { ReactSVG } from "react-svg";

// region Imports - Assets
import TopConLogo from "@assets/company/TopconTheConcreteSuiteWhite.svg";
// endregion Imports - Assets
// region Imports - Atoms
import LoginBackground from "@atoms/LoginBackground";
// endregion Imports - Atoms
// region Imports - Molecules
import ForgotPasswordForm from "@molecules/FormForgotPassword";
// endregion Imports - Molecules
// region Imports - Hooks
import { useAuth } from "@hooks/useAuth";
// endregion Imports - Hooks
// region Imports - Styles
import * as Styled from "./styles";
// endregion Imports - Styles

const ForgotPassword: React.FC = () => {

  const { user } = useAuth();

  if (user) return <Navigate to="/" />;

  return (
    <Styled.ForgotPasswordContainer>
      <LoginBackground />
      <Styled.ForgotPasswordFormContainer>
        <ForgotPasswordForm />
        <Styled.ForgotPasswordTelluriaGroupContainer>
          <ReactSVG src={TopConLogo} />
        </Styled.ForgotPasswordTelluriaGroupContainer>
      </Styled.ForgotPasswordFormContainer>
    </Styled.ForgotPasswordContainer>
  );
};

export default ForgotPassword;
